<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat>
      <v-card-title>
        {{ businessMetric.name }} Data
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="business_metric_items"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, 100]
          }"
        >
          <template v-slot:body.prepend="{}">
            <edit-business-metric-item
              v-on:save="resetNewDataItem"
              v-on:cancel="resetNewDataItem"
              :data-item="newDataItem"
            ></edit-business-metric-item>
          </template>
          <template v-slot:item="{ item }">
            <edit-business-metric-item
              v-if="expandedId == item.id"
              v-on:save="expandedId = null"
              v-on:cancel="expandedId = null"
              :data-item="item"
            ></edit-business-metric-item>
            <tr v-else>
              <td>
                {{ item.date | normalDateNoTz }}
              </td>
              <td>
                <template
                  v-if="
                    businessMetric.unitId ==
                      $enums.businessMetricUnitTypes.CURRENCY
                  "
                >
                  {{ item.value | currency }}
                </template>
                <template
                  v-else-if="
                    businessMetric.unitId ==
                      $enums.businessMetricUnitTypes.PERCENTAGE
                  "
                >
                  {{ item.value | no_decimal }}%
                </template>
                <template
                  v-else-if="
                    businessMetric.unitId ==
                      $enums.businessMetricUnitTypes.COUNT
                  "
                >
                  {{ item.value | no_decimal }}
                </template>
              </td>
              <td>
                <v-btn icon @click="expandedId = item.id" v-if="!saving">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn icon @click="deleteItem(item)" :loading="saving">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import EditBusinessMetricItem from "@/components/metrics/EditBusinessMetricItem";
export default {
  name: "BusinessMetricItemsDialog",
  components: { EditBusinessMetricItem },
  props: {},
  data: () => ({
    dialog: false,
    saving: false,
    businessMetric: {},
    expandedId: null,
    headers: [
      { text: "Date", value: "date" },
      { text: "Value", value: "value" },
      { text: "", value: "data-table-expand" }
    ],
    newDataItem: {}
  }),
  watch: {},
  computed: {
    ...mapGetters({
      business_metric_items: "company/business_metric_items"
    })
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    loadItems() {
      this.loading = true;
      this.$store
        .dispatch("company/getBusinessMetricItems", this.businessMetric.id)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while loading."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showDialog(businessMetric) {
      this.dialog = true;
      this.businessMetric = this._.cloneDeep(businessMetric);
      this.resetNewDataItem();
      this.loadItems();
    },
    resetNewDataItem() {
      this.newDataItem = { businessMetricId: this.businessMetric.id };
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          "Delete data item",
          "Are you sure you want to delete this data item?",
          { color: "red" }
        )
      ) {
        this.saving = true;
        this.$store
          .dispatch("company/deleteBusinessMetricItem", item)
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while deleting."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
